import MainLogo from "@/assets/icons/main-logo.svg?react";
import { viewport } from "@telegram-apps/sdk-react";
import { Portal } from "react-portal";
import { Link, useLocation } from "react-router";

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

const INVISIBLE_PATHS = ["/auth"];

const Logo = () => {
  const { pathname } = useLocation();

  if (INVISIBLE_PATHS.includes(pathname)) {
    return null;
  }

  if (!isMobile || !viewport.requestFullscreen.isAvailable()) {
    return null;
  }

  const safeAreaInsetTop = viewport.safeAreaInsetTop();

  return (
    <Portal>
      <div
        className="fixed bg-dark flex-center pb-2 left-0 w-full top-0 z-50"
        style={{ paddingTop: safeAreaInsetTop + 11 + "px" }}
      >
        <Link to="/">
          <MainLogo />
        </Link>
      </div>
    </Portal>
  );
};

export default Logo;
